import styled from "styled-components";

import { pageRoot } from "../../../styles/pageRoot";
import {
  AdminContentCard,
  AdminHeaderRow,
  AdminSearchBar,
} from "../../../styles/adminPage";

export const Container = styled.div`
  ${pageRoot}
  background: ${({ theme }) => theme.colors.layoutBg};
`;

export const Main = styled.main`
  flex: 1;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 3.2rem 1.2rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  @media (min-width: 900px) {
    padding: 4rem 0 5rem;
  }
`;

export const SearchBar = styled(AdminSearchBar)`
  width: 100%;
  max-width: none;
  margin: 0;
`;

export const Content = styled(AdminContentCard)`
  width: 100%;
  max-width: none;
  margin: 0;
`;

export const HeaderContent = styled(AdminHeaderRow)`
  margin-bottom: 2rem;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;
